// extracted by mini-css-extract-plugin
module.exports = {"information":"style_information__h2fzZ","wrapper":"style_wrapper__38sFk","sub_page":"style_sub_page__1WAUK","sections":"style_sections__5i0Pq"};